import { Quote } from "lucide-react";
import { TESTIMONIALS } from "@/lib/content";

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="relative py-24 md:py-32 bg-[#1A4331] overflow-hidden"
    >
      <div className="absolute -top-24 -right-24 h-96 w-96 rounded-full bg-[#D4A373]/15 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-32 -left-24 h-96 w-96 rounded-full bg-[#4A90E2]/10 blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 md:px-10 relative">
        <div className="max-w-2xl">
          <div className="text-xs uppercase tracking-widest font-semibold text-[#D4A373]">
            — Ils nous font confiance
          </div>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tighter text-white leading-tight">
            La satisfaction client,
            <br />notre meilleure carte de visite.
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="rounded-2xl bg-white/[0.06] border border-white/10 backdrop-blur-sm p-7 flex flex-col"
            >
              <Quote className="h-7 w-7 text-[#D4A373]" />
              <blockquote className="mt-5 text-base text-white/90 leading-relaxed flex-1">
                « {t.quote} »
              </blockquote>
              <figcaption className="mt-6 pt-6 border-t border-white/10">
                <div className="font-display text-base font-medium text-white">
                  {t.author}
                </div>
                <div className="text-xs text-white/60 uppercase tracking-wider mt-1">
                  {t.role}
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
